import { render, staticRenderFns } from "./RatingDisplay.vue?vue&type=template&id=45a561ee&"
import script from "./RatingDisplay.vue?vue&type=script&lang=js&"
export * from "./RatingDisplay.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('45a561ee')) {
      api.createRecord('45a561ee', component.options)
    } else {
      api.reload('45a561ee', component.options)
    }
    module.hot.accept("./RatingDisplay.vue?vue&type=template&id=45a561ee&", function () {
      api.rerender('45a561ee', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2gNK8t62JzWNO/JS/comp/RatingDisplay.vue"
export default component.exports